// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/gfa-icing-turbulence-chart-symbols.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/gfa-icing-turbulence-chart-symbols/gfa-freezing-level-contours.js';
import g1 from '../lessons/meteorology/gfa-icing-turbulence-chart-symbols/gfa-icing-turbulence-chart-symbols.js';

mount([g0, g1]);
